
interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/09b42268e64b75a1bdbfb319cdd0d3b1/d006109a30e331b05fb01253f30422e1.png"
              alt="The Way Lake"
              className="h-12 w-auto"
            />
          </div>
          <div className="flex items-center gap-8">
            <button
              onClick={() => scrollToSection('hero')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-sky-600' : 'text-white hover:text-sky-200'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('wildlife')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-sky-600' : 'text-white hover:text-sky-200'
              }`}
            >
              Wildlife
            </button>
            <button
              onClick={() => scrollToSection('activities')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-sky-600' : 'text-white hover:text-sky-200'
              }`}
            >
              Activities
            </button>
            <button
              onClick={() => scrollToSection('visitor-info')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-sky-600' : 'text-white hover:text-sky-200'
              }`}
            >
              Visitor Info
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-sky-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-sky-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
